import API from './API';

export default class BusinessUnitsAPI extends API {
  constructor(parameters = {}) {
    super('/BusinessUnits', parameters);
  }

  createBusinessUnit(data) {
    return this.submit("post", `${this.endpoint}`, data);
  }

  editBusinessUnit(data) {
    return this.submit("put", `${this.endpoint}`, data);
  }
}
